// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"FAQ_faqContainer__1UgWV","faqTitle":"FAQ_faqTitle__2rRhX"};